import type { Feature } from 'types'

type FeatureActiveProps = {
  features: Feature[];
  feature: string;
};

export const isFeatureActive = (
  {
    features = [],
    feature,
  }: FeatureActiveProps,
// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
): boolean => ((features.find(({ id }) => (id === feature)) || {}).active)
